// client/src/components/Admin/Dashboard/_shared/InfoPanel.js
//
// M06 Fase 7 - Panel informativo simple para placeholders y notas.

import React from "react";
import styles from "./InfoPanel.module.scss";

export function InfoPanel({ label, children }) {
  return (
    <div className={styles.infoPanel}>
      {label ? <div className={styles.label}>{label}</div> : null}
      <div>{children}</div>
    </div>
  );
}
